import { AvField } from "availity-reactstrap-validation"
import { useEffect, useState } from "react"
import { Alert, Row, Col } from "reactstrap"
import Licensing from "services/Licensing.service"

const user = JSON.parse(localStorage.getItem("authUser"))
let licensingService = new Licensing(user)

const RotterdamForm = props => {
  const [measures, setmeasures] = useState()
  const [editMode, setEditMode] = useState()
  const [editAnnex3, seteditAnnex3] = useState()
  const [editRegulatory, seteditRegulatory] = useState()
  useEffect(() => {
    fetchQuantityMeasures()
    if(props.editMode) {
      if(props.appDetails.rotterdam_convention.is_annex3) {
        seteditAnnex3("yes")
      } else {
        seteditAnnex3("no")
      }

    }
  }, [])

  const fetchQuantityMeasures = () => {
    licensingService.getQuantityMeasures().then(response => {
      //console.log(response)
      if (response.status) {
        const meas = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setmeasures(meas)
      }
    })
  }
  return (
    <>
      <h5>Form for Export and Import Notification</h5>

      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Registration Number
            </label>
            <div className="col-lg-9">
              <AvField
                type="text"
                name="registration_number"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.rotterdam_convention.registration_number
                    : ""
                }
              />
            </div>
          </Row>
        </Col>

        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Exporting/Importing Country
            </label>
            <div className="col-lg-9">
              <AvField
                type="select"
                name="state_of_dispatch"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.rotterdam_convention.state_of_dispatch
                    : ""
                }
              >
                <option>--Select--</option>
                <option value="Afganistan">Afghanistan</option>
                <option value="Albania">Albania</option>
                <option value="Algeria">Algeria</option>
                <option value="American Samoa">American Samoa</option>
                <option value="Andorra">Andorra</option>
                <option value="Angola">Angola</option>
                <option value="Anguilla">Anguilla</option>
                <option value="Antigua & Barbuda">Antigua & Barbuda</option>
                <option value="Argentina">Argentina</option>
                <option value="Armenia">Armenia</option>
                <option value="Aruba">Aruba</option>
                <option value="Australia">Australia</option>
                <option value="Austria">Austria</option>
                <option value="Azerbaijan">Azerbaijan</option>
                <option value="Bahamas">Bahamas</option>
                <option value="Bahrain">Bahrain</option>
                <option value="Bangladesh">Bangladesh</option>
                <option value="Barbados">Barbados</option>
                <option value="Belarus">Belarus</option>
                <option value="Belgium">Belgium</option>
                <option value="Belize">Belize</option>
                <option value="Benin">Benin</option>
                <option value="Bermuda">Bermuda</option>
                <option value="Bhutan">Bhutan</option>
                <option value="Bolivia">Bolivia</option>
                <option value="Bonaire">Bonaire</option>
                <option value="Bosnia & Herzegovina">
                  Bosnia & Herzegovina
                </option>
                <option value="Botswana">Botswana</option>
                <option value="Brazil">Brazil</option>
                <option value="British Indian Ocean Ter">
                  British Indian Ocean Ter
                </option>
                <option value="Brunei">Brunei</option>
                <option value="Bulgaria">Bulgaria</option>
                <option value="Burkina Faso">Burkina Faso</option>
                <option value="Burundi">Burundi</option>
                <option value="Cambodia">Cambodia</option>
                <option value="Cameroon">Cameroon</option>
                <option value="Canada">Canada</option>
                <option value="Canary Islands">Canary Islands</option>
                <option value="Cape Verde">Cape Verde</option>
                <option value="Cayman Islands">Cayman Islands</option>
                <option value="Central African Republic">
                  Central African Republic
                </option>
                <option value="Chad">Chad</option>
                <option value="Channel Islands">Channel Islands</option>
                <option value="Chile">Chile</option>
                <option value="China">China</option>
                <option value="Christmas Island">Christmas Island</option>
                <option value="Cocos Island">Cocos Island</option>
                <option value="Colombia">Colombia</option>
                <option value="Comoros">Comoros</option>
                <option value="Congo">Congo</option>
                <option value="Cook Islands">Cook Islands</option>
                <option value="Costa Rica">Costa Rica</option>
                <option value="Cote DIvoire">Cote DIvoire</option>
                <option value="Croatia">Croatia</option>
                <option value="Cuba">Cuba</option>
                <option value="Curaco">Curacao</option>
                <option value="Cyprus">Cyprus</option>
                <option value="Czech Republic">Czech Republic</option>
                <option value="Denmark">Denmark</option>
                <option value="Djibouti">Djibouti</option>
                <option value="Dominica">Dominica</option>
                <option value="Dominican Republic">Dominican Republic</option>
                <option value="East Timor">East Timor</option>
                <option value="Ecuador">Ecuador</option>
                <option value="Egypt">Egypt</option>
                <option value="El Salvador">El Salvador</option>
                <option value="Equatorial Guinea">Equatorial Guinea</option>
                <option value="Eritrea">Eritrea</option>
                <option value="Estonia">Estonia</option>
                <option value="Ethiopia">Ethiopia</option>
                <option value="Falkland Islands">Falkland Islands</option>
                <option value="Faroe Islands">Faroe Islands</option>
                <option value="Fiji">Fiji</option>
                <option value="Finland">Finland</option>
                <option value="France">France</option>
                <option value="French Guiana">French Guiana</option>
                <option value="French Polynesia">French Polynesia</option>
                <option value="French Southern Ter">French Southern Ter</option>
                <option value="Gabon">Gabon</option>
                <option value="Gambia">Gambia</option>
                <option value="Georgia">Georgia</option>
                <option value="Germany">Germany</option>
                <option value="Ghana">Ghana</option>
                <option value="Gibraltar">Gibraltar</option>
                <option value="Great Britain">Great Britain</option>
                <option value="Greece">Greece</option>
                <option value="Greenland">Greenland</option>
                <option value="Grenada">Grenada</option>
                <option value="Guadeloupe">Guadeloupe</option>
                <option value="Guam">Guam</option>
                <option value="Guatemala">Guatemala</option>
                <option value="Guinea">Guinea</option>
                <option value="Guyana">Guyana</option>
                <option value="Haiti">Haiti</option>
                <option value="Hawaii">Hawaii</option>
                <option value="Honduras">Honduras</option>
                <option value="Hong Kong">Hong Kong</option>
                <option value="Hungary">Hungary</option>
                <option value="Iceland">Iceland</option>
                <option value="Indonesia">Indonesia</option>
                <option value="India">India</option>
                <option value="Iran">Iran</option>
                <option value="Iraq">Iraq</option>
                <option value="Ireland">Ireland</option>
                <option value="Isle of Man">Isle of Man</option>
                <option value="Israel">Israel</option>
                <option value="Italy">Italy</option>
                <option value="Jamaica">Jamaica</option>
                <option value="Japan">Japan</option>
                <option value="Jordan">Jordan</option>
                <option value="Kazakhstan">Kazakhstan</option>
                <option value="Kenya">Kenya</option>
                <option value="Kiribati">Kiribati</option>
                <option value="Korea North">Korea North</option>
                <option value="Korea Sout">Korea South</option>
                <option value="Kuwait">Kuwait</option>
                <option value="Kyrgyzstan">Kyrgyzstan</option>
                <option value="Laos">Laos</option>
                <option value="Latvia">Latvia</option>
                <option value="Lebanon">Lebanon</option>
                <option value="Lesotho">Lesotho</option>
                <option value="Liberia">Liberia</option>
                <option value="Libya">Libya</option>
                <option value="Liechtenstein">Liechtenstein</option>
                <option value="Lithuania">Lithuania</option>
                <option value="Luxembourg">Luxembourg</option>
                <option value="Macau">Macau</option>
                <option value="Macedonia">Macedonia</option>
                <option value="Madagascar">Madagascar</option>
                <option value="Malaysia">Malaysia</option>
                <option value="Malawi">Malawi</option>
                <option value="Maldives">Maldives</option>
                <option value="Mali">Mali</option>
                <option value="Malta">Malta</option>
                <option value="Marshall Islands">Marshall Islands</option>
                <option value="Martinique">Martinique</option>
                <option value="Mauritania">Mauritania</option>
                <option value="Mauritius">Mauritius</option>
                <option value="Mayotte">Mayotte</option>
                <option value="Mexico">Mexico</option>
                <option value="Midway Islands">Midway Islands</option>
                <option value="Moldova">Moldova</option>
                <option value="Monaco">Monaco</option>
                <option value="Mongolia">Mongolia</option>
                <option value="Montserrat">Montserrat</option>
                <option value="Morocco">Morocco</option>
                <option value="Mozambique">Mozambique</option>
                <option value="Myanmar">Myanmar</option>
                <option value="Nambia">Nambia</option>
                <option value="Nauru">Nauru</option>
                <option value="Nepal">Nepal</option>
                <option value="Netherland Antilles">Netherland Antilles</option>
                <option value="Netherlands">
                  Netherlands (Holland, Europe)
                </option>
                <option value="Nevis">Nevis</option>
                <option value="New Caledonia">New Caledonia</option>
                <option value="New Zealand">New Zealand</option>
                <option value="Nicaragua">Nicaragua</option>
                <option value="Niger">Niger</option>
                <option value="Nigeria">Nigeria</option>
                <option value="Niue">Niue</option>
                <option value="Norfolk Island">Norfolk Island</option>
                <option value="Norway">Norway</option>
                <option value="Oman">Oman</option>
                <option value="Pakistan">Pakistan</option>
                <option value="Palau Island">Palau Island</option>
                <option value="Palestine">Palestine</option>
                <option value="Panama">Panama</option>
                <option value="Papua New Guinea">Papua New Guinea</option>
                <option value="Paraguay">Paraguay</option>
                <option value="Peru">Peru</option>
                <option value="Phillipines">Philippines</option>
                <option value="Pitcairn Island">Pitcairn Island</option>
                <option value="Poland">Poland</option>
                <option value="Portugal">Portugal</option>
                <option value="Puerto Rico">Puerto Rico</option>
                <option value="Qatar">Qatar</option>
                <option value="Republic of Montenegro">
                  Republic of Montenegro
                </option>
                <option value="Republic of Serbia">Republic of Serbia</option>
                <option value="Reunion">Reunion</option>
                <option value="Romania">Romania</option>
                <option value="Russia">Russia</option>
                <option value="Rwanda">Rwanda</option>
                <option value="St Barthelemy">St Barthelemy</option>
                <option value="St Eustatius">St Eustatius</option>
                <option value="St Helena">St Helena</option>
                <option value="St Kitts-Nevis">St Kitts-Nevis</option>
                <option value="St Lucia">St Lucia</option>
                <option value="St Maarten">St Maarten</option>
                <option value="St Pierre & Miquelon">
                  St Pierre & Miquelon
                </option>
                <option value="St Vincent & Grenadines">
                  St Vincent & Grenadines
                </option>
                <option value="Saipan">Saipan</option>
                <option value="Samoa">Samoa</option>
                <option value="Samoa American">Samoa American</option>
                <option value="San Marino">San Marino</option>
                <option value="Sao Tome & Principe">Sao Tome & Principe</option>
                <option value="Saudi Arabia">Saudi Arabia</option>
                <option value="Senegal">Senegal</option>
                <option value="Seychelles">Seychelles</option>
                <option value="Sierra Leone">Sierra Leone</option>
                <option value="Singapore">Singapore</option>
                <option value="Slovakia">Slovakia</option>
                <option value="Slovenia">Slovenia</option>
                <option value="Solomon Islands">Solomon Islands</option>
                <option value="Somalia">Somalia</option>
                <option value="South Africa">South Africa</option>
                <option value="Spain">Spain</option>
                <option value="Sri Lanka">Sri Lanka</option>
                <option value="Sudan">Sudan</option>
                <option value="Suriname">Suriname</option>
                <option value="Swaziland">Swaziland</option>
                <option value="Sweden">Sweden</option>
                <option value="Switzerland">Switzerland</option>
                <option value="Syria">Syria</option>
                <option value="Tahiti">Tahiti</option>
                <option value="Taiwan">Taiwan</option>
                <option value="Tajikistan">Tajikistan</option>
                <option value="Tanzania">Tanzania</option>
                <option value="Thailand">Thailand</option>
                <option value="Togo">Togo</option>
                <option value="Tokelau">Tokelau</option>
                <option value="Tonga">Tonga</option>
                <option value="Trinidad & Tobago">Trinidad & Tobago</option>
                <option value="Tunisia">Tunisia</option>
                <option value="Turkey">Turkey</option>
                <option value="Turkmenistan">Turkmenistan</option>
                <option value="Turks & Caicos Is">Turks & Caicos Is</option>
                <option value="Tuvalu">Tuvalu</option>
                <option value="Uganda">Uganda</option>
                <option value="United Kingdom">United Kingdom</option>
                <option value="Ukraine">Ukraine</option>
                <option value="United Arab Erimates">
                  United Arab Emirates
                </option>
                <option value="United States of America">
                  United States of America
                </option>
                <option value="Uraguay">Uruguay</option>
                <option value="Uzbekistan">Uzbekistan</option>
                <option value="Vanuatu">Vanuatu</option>
                <option value="Vatican City State">Vatican City State</option>
                <option value="Venezuela">Venezuela</option>
                <option value="Vietnam">Vietnam</option>
                <option value="Virgin Islands (Brit)">
                  Virgin Islands (Brit)
                </option>
                <option value="Virgin Islands (USA)">
                  Virgin Islands (USA)
                </option>
                <option value="Wake Island">Wake Island</option>
                <option value="Wallis & Futana Is">Wallis & Futana Is</option>
                <option value="Yemen">Yemen</option>
                <option value="Zaire">Zaire</option>
                <option value="Zambia">Zambia</option>
                <option value="Zimbabwe">Zimbabwe</option>
              </AvField>
            </div>
          </Row>
        </Col>
      </Row>

      <hr></hr>
      <h5>
        SECTION 1 - IDENTITY OF THE CHEMICAL SUBJECT TO THE EXPORT NOTIFICATION
      </h5>

      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Common Name
            </label>
            <div className="col-lg-9">
              <AvField
                type="text"
                name="chemical_common_name"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.rotterdam_convention.chemical_common_name
                    : ""
                }
              />
            </div>
          </Row>
        </Col>

        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Chemical name according to an internationally recognized
              nomenclature (e.g. IUPAC)
            </label>
            <div className="col-lg-9">
              <AvField
                type="textarea"
                name="chemical_international_name"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.rotterdam_convention.chemical_international_name
                    : ""
                }
              ></AvField>
            </div>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Total intended quantity
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField type="number" name="quantity" label="" required value={
                  props.editMode
                    ? props.appDetails.rotterdam_convention.quantity
                    : ""
                }/>
            </div>
          </Row>
        </Col>

        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Quantity measure
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="select"
                name="quantity_measure_id"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.rotterdam_convention.quantity_measure_id
                    : ""
                }
              >
                <option value="">--select--</option>
                {measures}
              </AvField>
            </div>
          </Row>
        </Col>
      </Row>

      <h6>Code Numbers</h6>
      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Total intended number of shipments
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="number"
                name="number_of_shipments"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.rotterdam_convention.number_of_shipments
                    : ""
                }
              />
            </div>
          </Row>
        </Col>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              CAS number
            </label>
            <div className="col-lg-9">
              <AvField type="text" name="cas_number" required label="" value={
                  props.editMode
                    ? props.appDetails.rotterdam_convention.cas_number
                    : ""
                }/>
            </div>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Is this chemical under annex 3 of Rotterdam convention?
            </label>
            <div className="col-lg-9">
              <AvField type="select" name="is_annex3" required label="" value={editAnnex3}>
                <option>--Select--</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </AvField>
            </div>
          </Row>
        </Col>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Harmonized system customs code
            </label>
            <div className="col-lg-9">
              <AvField type="text" name="harmonized_code" required label="" value={
                  props.editMode
                    ? props.appDetails.rotterdam_convention.harmonized_code
                    : ""
                } />
            </div>
          </Row>
        </Col>
      </Row>

      <hr></hr>
      <h5>SECTION 2 - IDENTITY OF THE PREPARATION TO BE EXPORTED</h5>

      <Row>
        <Col md={12}>
          <Row>Trade name and name of the preparation</Row>
          <Row className="mb-3">
            <div className="col-lg-12">
              <AvField type="text" name="trade_name" required label="" value={
                  props.editMode
                    ? props.appDetails.rotterdam_convention.trade_name
                    : ""
                } />
            </div>
          </Row>
        </Col>

        <Col md={12}>
          <Row className="mb-3">
            For each substance in the preparation that is subject to the export
            notification, concentration (%) and information as specified under
            SECTION 1For each substance in the preparation that is subject to
            the export notification, concentration (%) and information as
            specified under SECTION 1 For each substance in the preparation that
            is subject to the export notification, concentration (%) and
            information as specified under SECTION 1
          </Row>
          <Row className="mb-3">
            <div className="col-lg-12">
              <AvField
                type="textarea"
                name="description_identity_preparation"
                required
                label=""
                value={
                  props.editMode
                    ? props.appDetails.rotterdam_convention.description_identity_preparation
                    : ""
                }
              ></AvField>
            </div>
          </Row>
        </Col>
      </Row>

      <hr></hr>
      <h5>SECTION 3 - INFORMATION CONCERNING THE EXPORT</h5>
      <Row>
        <Col md="12">
          <Row>Expected date of export</Row>
          <Row>
            <AvField type="date" name="expected_date_of_export" required value={
                  props.editMode
                    ? props.appDetails.rotterdam_convention.expected_date_of_export
                    : ""
                } />
          </Row>
        </Col>
        <br></br>
        <Col md="12">
          <Row>
            Foreseen category (industrial chemical or pesticide) and foreseen
            use in importing country
          </Row>
          <Row>
            <AvField
              type="textarea"
              name="foreseen_category"
              required
              value={
                props.editMode
                  ? props.appDetails.rotterdam_convention.foreseen_category
                  : ""
              }
            ></AvField>
          </Row>
        </Col>
      </Row>

      <br></br>
      <h5>Exporter Address</h5>
      <Row>
        <div>Name</div>
        <div>
          <AvField type="text" name="name_of_importer" required value={
                props.editMode
                  ? props.appDetails.rotterdam_convention.name_of_importer
                  : ""
              } />
        </div>
      </Row>

      <br></br>
      <Row>
        <div>Address</div>
        <div>
          <AvField type="text" name="address" required value={
                props.editMode
                  ? props.appDetails.rotterdam_convention.address
                  : ""
              }  />
        </div>
      </Row>

      <br></br>
      <Row>
        <div>Email</div>
        <div>
          <AvField type="text" name="email" required value={
                props.editMode
                  ? props.appDetails.rotterdam_convention.email
                  : ""
              }  />
        </div>
      </Row>

      <br></br>
      <Row>
        <div>Fax</div>
        <div>
          <AvField type="text" name="fax" value={
                props.editMode
                  ? props.appDetails.rotterdam_convention.fax
                  : ""
              }  />
        </div>
      </Row>

      <hr></hr>
      <h5>
        SECTION 4 - INFORMATION ON HAZARDS AND /OR RISKS OF THE CHEMICAL AND
        PRECAUTIONARY MEASURES
      </h5>
      <br></br>
      <Row>
        <div>Hazard classification (e.g. GHS, WHO, IARC, EU)</div>
        <div>
          <AvField type="text" name="hazard_classification" required value={
                props.editMode
                  ? props.appDetails.rotterdam_convention.hazard_classification
                  : ""
              } />
        </div>
      </Row>

      <br></br>
      <Row>
        <div>Information on hazards and/or risks</div>
        <div>
          <AvField
            type="textarea"
            name="information_on_hazards"
            required
            value={
              props.editMode
                ? props.appDetails.rotterdam_convention.information_on_hazards
                : ""
            }
          ></AvField>
        </div>
      </Row>

      <br></br>
      <Row>
        <div>
          Information on precautionary measures to reduce exposure to and
          emission of the chemical
        </div>
        <div>
          <AvField
            type="textarea"
            name="information_on_precautionary"
            required
            value={
              props.editMode
                ? props.appDetails.rotterdam_convention.information_on_precautionary
                : ""
            }
          ></AvField>
        </div>
      </Row>

      <br></br>
      <Row>
        <div>
          Further information that may be useful to the importing country or has
          been requested by it, if available
        </div>
        <div>
          <AvField
            type="textarea"
            name="additional_information"
            required
            value={
              props.editMode
                ? props.appDetails.rotterdam_convention.additional_information
                : ""
            }
          ></AvField>
        </div>
      </Row>

      <hr></hr>
      <h5>
        SECTION 5 - INFORMATION ON PHYSICO-CHEMICAL, TOXICOLOGICAL AND
        ECOTOXICOLOGICAL PROPERTIES OF THE CHEMCIAL
      </h5>
      <br></br>
      <Row>
        <div>Summary information</div>
        <div>
          <AvField
            type="textarea"
            name="summary_information_physio"
            required
            value={
              props.editMode
                ? props.appDetails.rotterdam_convention.summary_information_physio
                : ""
            }
          ></AvField>
        </div>
      </Row>

      <br></br>
      <Row>
        <div>Reference</div>
        <div>
          <AvField type="text" name="reference" required value={
              props.editMode
                ? props.appDetails.rotterdam_convention.reference
                : ""
            } />
        </div>
      </Row>

      <hr></hr>
      <h5>
        SECTION 6 - SUMMARY INFORMATION ON FINAL REGULATORY ACTION TAKEN BY THE
        EXPORTING COUNTRY
      </h5>
      <br></br>
      <Row>
        <div>
          Summary of the final regulatory action and data of entry into force
        </div>
        <div>
          <AvField type="text" name="summary_information_regulatory" required value={
              props.editMode
                ? props.appDetails.rotterdam_convention.summary_information_regulatory
                : ""
            } />
        </div>
      </Row>

      <br></br>
      <Row>
        <div>The final regulatory action has been taken for the category</div>
        <div>
          <AvField type="select" name="category" required value={
              props.editMode
                ? props.appDetails.rotterdam_convention.category
                : ""
            } >
            <option>--Select--</option>
            <option value="pesticide">Pesticide</option>
            <option value="industrial_chemical">Industrial Chemical</option>
          </AvField>
        </div>
      </Row>

      <br></br>
      <Row>
        <div>
          <p>
            Please indicate:
            <br></br>-use or uses prohibited
            <br></br>-use or uses that remain allowed
            <br></br>-where available, estimated quantity of the chemical
            produced, imported, exported and used
          </p>
        </div>
        <div>
          <AvField type="textarea" name="uses_prohibited" required value={
              props.editMode
                ? props.appDetails.rotterdam_convention.uses_prohibited
                : ""
            }  ></AvField>
        </div>
      </Row>

      <br></br>
      <Row>
        <div>Reference to the regulatory document</div>
        <div>
          <AvField
            type="text"
            name="reference_to_regulatory_document"
            required
            value={
              props.editMode
                ? props.appDetails.rotterdam_convention.reference_to_regulatory_document
                : ""
            }
          />
        </div>
      </Row>

      <hr></hr>
      <h5>SECTION 7 - DESIGNATED NATIONAL AUTHORITIES (DNAs)</h5>
      <h6>Notifying DNA in the exporting country</h6>

      <Row>
        <div>Name</div>
        <div>
          <AvField type="select" name="dna_country" required label="" value={
              props.editMode
                ? props.appDetails.rotterdam_convention.dna_country
                : ""
            } >
            <option>--Select--</option>
            <option value="Afganistan">Afghanistan</option>
            <option value="Albania">Albania</option>
            <option value="Algeria">Algeria</option>
            <option value="American Samoa">American Samoa</option>
            <option value="Andorra">Andorra</option>
            <option value="Angola">Angola</option>
            <option value="Anguilla">Anguilla</option>
            <option value="Antigua & Barbuda">Antigua & Barbuda</option>
            <option value="Argentina">Argentina</option>
            <option value="Armenia">Armenia</option>
            <option value="Aruba">Aruba</option>
            <option value="Australia">Australia</option>
            <option value="Austria">Austria</option>
            <option value="Azerbaijan">Azerbaijan</option>
            <option value="Bahamas">Bahamas</option>
            <option value="Bahrain">Bahrain</option>
            <option value="Bangladesh">Bangladesh</option>
            <option value="Barbados">Barbados</option>
            <option value="Belarus">Belarus</option>
            <option value="Belgium">Belgium</option>
            <option value="Belize">Belize</option>
            <option value="Benin">Benin</option>
            <option value="Bermuda">Bermuda</option>
            <option value="Bhutan">Bhutan</option>
            <option value="Bolivia">Bolivia</option>
            <option value="Bonaire">Bonaire</option>
            <option value="Bosnia & Herzegovina">Bosnia & Herzegovina</option>
            <option value="Botswana">Botswana</option>
            <option value="Brazil">Brazil</option>
            <option value="British Indian Ocean Ter">
              British Indian Ocean Ter
            </option>
            <option value="Brunei">Brunei</option>
            <option value="Bulgaria">Bulgaria</option>
            <option value="Burkina Faso">Burkina Faso</option>
            <option value="Burundi">Burundi</option>
            <option value="Cambodia">Cambodia</option>
            <option value="Cameroon">Cameroon</option>
            <option value="Canada">Canada</option>
            <option value="Canary Islands">Canary Islands</option>
            <option value="Cape Verde">Cape Verde</option>
            <option value="Cayman Islands">Cayman Islands</option>
            <option value="Central African Republic">
              Central African Republic
            </option>
            <option value="Chad">Chad</option>
            <option value="Channel Islands">Channel Islands</option>
            <option value="Chile">Chile</option>
            <option value="China">China</option>
            <option value="Christmas Island">Christmas Island</option>
            <option value="Cocos Island">Cocos Island</option>
            <option value="Colombia">Colombia</option>
            <option value="Comoros">Comoros</option>
            <option value="Congo">Congo</option>
            <option value="Cook Islands">Cook Islands</option>
            <option value="Costa Rica">Costa Rica</option>
            <option value="Cote DIvoire">Cote DIvoire</option>
            <option value="Croatia">Croatia</option>
            <option value="Cuba">Cuba</option>
            <option value="Curaco">Curacao</option>
            <option value="Cyprus">Cyprus</option>
            <option value="Czech Republic">Czech Republic</option>
            <option value="Denmark">Denmark</option>
            <option value="Djibouti">Djibouti</option>
            <option value="Dominica">Dominica</option>
            <option value="Dominican Republic">Dominican Republic</option>
            <option value="East Timor">East Timor</option>
            <option value="Ecuador">Ecuador</option>
            <option value="Egypt">Egypt</option>
            <option value="El Salvador">El Salvador</option>
            <option value="Equatorial Guinea">Equatorial Guinea</option>
            <option value="Eritrea">Eritrea</option>
            <option value="Estonia">Estonia</option>
            <option value="Ethiopia">Ethiopia</option>
            <option value="Falkland Islands">Falkland Islands</option>
            <option value="Faroe Islands">Faroe Islands</option>
            <option value="Fiji">Fiji</option>
            <option value="Finland">Finland</option>
            <option value="France">France</option>
            <option value="French Guiana">French Guiana</option>
            <option value="French Polynesia">French Polynesia</option>
            <option value="French Southern Ter">French Southern Ter</option>
            <option value="Gabon">Gabon</option>
            <option value="Gambia">Gambia</option>
            <option value="Georgia">Georgia</option>
            <option value="Germany">Germany</option>
            <option value="Ghana">Ghana</option>
            <option value="Gibraltar">Gibraltar</option>
            <option value="Great Britain">Great Britain</option>
            <option value="Greece">Greece</option>
            <option value="Greenland">Greenland</option>
            <option value="Grenada">Grenada</option>
            <option value="Guadeloupe">Guadeloupe</option>
            <option value="Guam">Guam</option>
            <option value="Guatemala">Guatemala</option>
            <option value="Guinea">Guinea</option>
            <option value="Guyana">Guyana</option>
            <option value="Haiti">Haiti</option>
            <option value="Hawaii">Hawaii</option>
            <option value="Honduras">Honduras</option>
            <option value="Hong Kong">Hong Kong</option>
            <option value="Hungary">Hungary</option>
            <option value="Iceland">Iceland</option>
            <option value="Indonesia">Indonesia</option>
            <option value="India">India</option>
            <option value="Iran">Iran</option>
            <option value="Iraq">Iraq</option>
            <option value="Ireland">Ireland</option>
            <option value="Isle of Man">Isle of Man</option>
            <option value="Israel">Israel</option>
            <option value="Italy">Italy</option>
            <option value="Jamaica">Jamaica</option>
            <option value="Japan">Japan</option>
            <option value="Jordan">Jordan</option>
            <option value="Kazakhstan">Kazakhstan</option>
            <option value="Kenya">Kenya</option>
            <option value="Kiribati">Kiribati</option>
            <option value="Korea North">Korea North</option>
            <option value="Korea Sout">Korea South</option>
            <option value="Kuwait">Kuwait</option>
            <option value="Kyrgyzstan">Kyrgyzstan</option>
            <option value="Laos">Laos</option>
            <option value="Latvia">Latvia</option>
            <option value="Lebanon">Lebanon</option>
            <option value="Lesotho">Lesotho</option>
            <option value="Liberia">Liberia</option>
            <option value="Libya">Libya</option>
            <option value="Liechtenstein">Liechtenstein</option>
            <option value="Lithuania">Lithuania</option>
            <option value="Luxembourg">Luxembourg</option>
            <option value="Macau">Macau</option>
            <option value="Macedonia">Macedonia</option>
            <option value="Madagascar">Madagascar</option>
            <option value="Malaysia">Malaysia</option>
            <option value="Malawi">Malawi</option>
            <option value="Maldives">Maldives</option>
            <option value="Mali">Mali</option>
            <option value="Malta">Malta</option>
            <option value="Marshall Islands">Marshall Islands</option>
            <option value="Martinique">Martinique</option>
            <option value="Mauritania">Mauritania</option>
            <option value="Mauritius">Mauritius</option>
            <option value="Mayotte">Mayotte</option>
            <option value="Mexico">Mexico</option>
            <option value="Midway Islands">Midway Islands</option>
            <option value="Moldova">Moldova</option>
            <option value="Monaco">Monaco</option>
            <option value="Mongolia">Mongolia</option>
            <option value="Montserrat">Montserrat</option>
            <option value="Morocco">Morocco</option>
            <option value="Mozambique">Mozambique</option>
            <option value="Myanmar">Myanmar</option>
            <option value="Nambia">Nambia</option>
            <option value="Nauru">Nauru</option>
            <option value="Nepal">Nepal</option>
            <option value="Netherland Antilles">Netherland Antilles</option>
            <option value="Netherlands">Netherlands (Holland, Europe)</option>
            <option value="Nevis">Nevis</option>
            <option value="New Caledonia">New Caledonia</option>
            <option value="New Zealand">New Zealand</option>
            <option value="Nicaragua">Nicaragua</option>
            <option value="Niger">Niger</option>
            <option value="Nigeria">Nigeria</option>
            <option value="Niue">Niue</option>
            <option value="Norfolk Island">Norfolk Island</option>
            <option value="Norway">Norway</option>
            <option value="Oman">Oman</option>
            <option value="Pakistan">Pakistan</option>
            <option value="Palau Island">Palau Island</option>
            <option value="Palestine">Palestine</option>
            <option value="Panama">Panama</option>
            <option value="Papua New Guinea">Papua New Guinea</option>
            <option value="Paraguay">Paraguay</option>
            <option value="Peru">Peru</option>
            <option value="Phillipines">Philippines</option>
            <option value="Pitcairn Island">Pitcairn Island</option>
            <option value="Poland">Poland</option>
            <option value="Portugal">Portugal</option>
            <option value="Puerto Rico">Puerto Rico</option>
            <option value="Qatar">Qatar</option>
            <option value="Republic of Montenegro">
              Republic of Montenegro
            </option>
            <option value="Republic of Serbia">Republic of Serbia</option>
            <option value="Reunion">Reunion</option>
            <option value="Romania">Romania</option>
            <option value="Russia">Russia</option>
            <option value="Rwanda">Rwanda</option>
            <option value="St Barthelemy">St Barthelemy</option>
            <option value="St Eustatius">St Eustatius</option>
            <option value="St Helena">St Helena</option>
            <option value="St Kitts-Nevis">St Kitts-Nevis</option>
            <option value="St Lucia">St Lucia</option>
            <option value="St Maarten">St Maarten</option>
            <option value="St Pierre & Miquelon">St Pierre & Miquelon</option>
            <option value="St Vincent & Grenadines">
              St Vincent & Grenadines
            </option>
            <option value="Saipan">Saipan</option>
            <option value="Samoa">Samoa</option>
            <option value="Samoa American">Samoa American</option>
            <option value="San Marino">San Marino</option>
            <option value="Sao Tome & Principe">Sao Tome & Principe</option>
            <option value="Saudi Arabia">Saudi Arabia</option>
            <option value="Senegal">Senegal</option>
            <option value="Seychelles">Seychelles</option>
            <option value="Sierra Leone">Sierra Leone</option>
            <option value="Singapore">Singapore</option>
            <option value="Slovakia">Slovakia</option>
            <option value="Slovenia">Slovenia</option>
            <option value="Solomon Islands">Solomon Islands</option>
            <option value="Somalia">Somalia</option>
            <option value="South Africa">South Africa</option>
            <option value="Spain">Spain</option>
            <option value="Sri Lanka">Sri Lanka</option>
            <option value="Sudan">Sudan</option>
            <option value="Suriname">Suriname</option>
            <option value="Swaziland">Swaziland</option>
            <option value="Sweden">Sweden</option>
            <option value="Switzerland">Switzerland</option>
            <option value="Syria">Syria</option>
            <option value="Tahiti">Tahiti</option>
            <option value="Taiwan">Taiwan</option>
            <option value="Tajikistan">Tajikistan</option>
            <option value="Tanzania">Tanzania</option>
            <option value="Thailand">Thailand</option>
            <option value="Togo">Togo</option>
            <option value="Tokelau">Tokelau</option>
            <option value="Tonga">Tonga</option>
            <option value="Trinidad & Tobago">Trinidad & Tobago</option>
            <option value="Tunisia">Tunisia</option>
            <option value="Turkey">Turkey</option>
            <option value="Turkmenistan">Turkmenistan</option>
            <option value="Turks & Caicos Is">Turks & Caicos Is</option>
            <option value="Tuvalu">Tuvalu</option>
            <option value="Uganda">Uganda</option>
            <option value="United Kingdom">United Kingdom</option>
            <option value="Ukraine">Ukraine</option>
            <option value="United Arab Erimates">United Arab Emirates</option>
            <option value="United States of America">
              United States of America
            </option>
            <option value="Uraguay">Uruguay</option>
            <option value="Uzbekistan">Uzbekistan</option>
            <option value="Vanuatu">Vanuatu</option>
            <option value="Vatican City State">Vatican City State</option>
            <option value="Venezuela">Venezuela</option>
            <option value="Vietnam">Vietnam</option>
            <option value="Virgin Islands (Brit)">Virgin Islands (Brit)</option>
            <option value="Virgin Islands (USA)">Virgin Islands (USA)</option>
            <option value="Wake Island">Wake Island</option>
            <option value="Wallis & Futana Is">Wallis & Futana Is</option>
            <option value="Yemen">Yemen</option>
            <option value="Zaire">Zaire</option>
            <option value="Zambia">Zambia</option>
            <option value="Zimbabwe">Zimbabwe</option>
          </AvField>
        </div>
      </Row>

      <br></br>
      <Row>
        <div>Address</div>
        <div>
          <AvField type="text" name="dna_address" required value={
              props.editMode
                ? props.appDetails.rotterdam_convention.dna_address
                : ""
            } />
        </div>
      </Row>

      <br></br>
      <Row>
        <div>Email</div>
        <div>
          <AvField type="text" name="dna_email" required value={
              props.editMode
                ? props.appDetails.rotterdam_convention.dna_email
                : ""
            } />
        </div>
      </Row>

      <br></br>
      <Row>
        <div>Fax</div>
        <div>
          <AvField type="text" name="dna_fax" value={
              props.editMode
                ? props.appDetails.rotterdam_convention.dna_fax
                : ""
            }  />
        </div>
      </Row>
      <br></br>
    </>
  )
}

export default RotterdamForm
